import { Navigate, useLocation, Outlet } from 'react-router';
import { useAppSelector } from '@/store/hooks';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  // Read-only demo mode is a valid way into the app shell. It is mutually
  // exclusive with real auth and never backed by a session (see authSlice).
  const isDemo = useAppSelector((state) => state.auth.isDemo);
  const location = useLocation();

  if (!isAuthenticated && !isDemo) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If children are provided, render them (legacy support)
  // Otherwise, render Outlet for nested routes
  return children ? <>{children}</> : <Outlet />;
}

export default ProtectedRoute;
